import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShoppingBag, Eye, Heart, MessageSquare, BarChart3, Loader2 } from "lucide-react";

export const EngagementTab = ({ darkMode, analytics }) => {
  const cardBg = darkMode ? "bg-gray-800/80 border border-gray-700/50" : "";
  const valText = darkMode ? "text-white" : "text-navy-900";
  const lblText = darkMode ? "text-gray-400" : "text-gray-500";

  if (!analytics) {
    return (
      <Card className={`border-0 shadow-soft rounded-3xl ${cardBg}`}>
        <CardContent>
          <div className="flex justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-gray-400" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={`border-0 shadow-soft rounded-3xl ${cardBg}`}>
      <CardHeader>
        <CardTitle className={`flex items-center gap-2 ${darkMode ? "text-gray-100" : ""}`}><BarChart3 className="w-5 h-5" /> Showcase Engagement</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: "Total Posts", value: analytics.totals.posts, icon: ShoppingBag, color: "text-blue-600 bg-blue-50", darkColor: "text-blue-400 bg-blue-900/30" },
              { label: "Total Views", value: analytics.totals.views, icon: Eye, color: "text-emerald-600 bg-emerald-50", darkColor: "text-emerald-400 bg-emerald-900/30" },
              { label: "Total Likes", value: analytics.totals.likes, icon: Heart, color: "text-red-500 bg-red-50", darkColor: "text-red-400 bg-red-900/30" },
              { label: "Total Inquiries", value: analytics.totals.inquiries, icon: MessageSquare, color: "text-amber-600 bg-amber-50", darkColor: "text-amber-400 bg-amber-900/30" },
            ].map(({ label, value, icon: Icon, color, darkColor }) => {
              const c = darkMode ? darkColor : color;
              return (
                <div key={label} className={`rounded-2xl p-4 ${c.split(" ")[1]}`}>
                  <Icon className={`w-5 h-5 ${c.split(" ")[0]} mb-2`} />
                  <p className={`text-2xl font-bold ${valText}`}>{value}</p>
                  <p className={`text-sm ${lblText}`}>{label}</p>
                </div>
              );
            })}
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              { title: "Top Liked", icon: <Heart className="w-4 h-4 text-red-500" />, data: analytics.top_liked, key: "likes" },
              { title: "Top Viewed", icon: <Eye className="w-4 h-4 text-emerald-500" />, data: analytics.top_viewed, key: "views" },
              { title: "Top Inquired", icon: <MessageSquare className="w-4 h-4 text-amber-500" />, data: analytics.top_inquired, key: "inquiries" },
            ].map(({ title, icon, data, key }) => (
              <div key={title}>
                <h4 className={`font-semibold mb-3 flex items-center gap-2 ${darkMode ? "text-gray-200" : ""}`}>{icon} {title}</h4>
                <div className="space-y-2">
                  {data.length > 0 ? data.map((p, i) => (
                    <div key={p.id || i} className={`flex justify-between items-center rounded-xl px-4 py-2.5 text-sm ${darkMode ? "bg-gray-700/50 text-gray-300" : "bg-gray-50"}`}>
                      <span className="truncate mr-2">{i + 1}. {p.title}</span>
                      <Badge variant="secondary" className="shrink-0">{p[key]}</Badge>
                    </div>
                  )) : (
                    <p className={`text-sm ${darkMode ? "text-gray-500" : "text-gray-400"}`}>No data yet</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
